import React, { useState } from 'react';
import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import { accountService } from '@/projects/admin/services/account-service';
import { accountEmailService } from '@/projects/admin/services/account-email-service';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';


const App = (props: any) => {
  const { accountId } = props;

  const [accountEmailStore] = useState(() =>
    createCustomStore({
    key: ['id'],
    load: accountEmailService.getAccountEmails,
    onLoading(loadOptions) {
      if (accountId) {
        loadOptions.filter = ["AccountId", "=", accountId]
      }
    },
    insert: accountEmailService.createAccountEmail,
    update: accountEmailService.updateAccountEmail,
    remove: accountEmailService.deleteAccountEmail,
  }));

  const [accountStore] = useState(() =>
    createCustomStore({
      key: 'id',
      load: accountService.lookupAccounts,
      byKey: (key, loadOptions: any) => {
        if (key) {
          loadOptions.filter = ["id", "=", key];
        }
      },
      onLoading(loadOptions) {
        if (accountId) {
          loadOptions.filter = ["Id", "=", accountId]
        }
      },
    }));



  const handleRowUpdating = async (e: any) => {
    e.newData = { ...e.oldData, ...e.newData }
  };

  return (

    <React.Fragment>
      <DataGridWrapper
        datasource={accountEmailStore}
        permissonCode='Admin.Account.Account'
        onRowUpdating={handleRowUpdating}
        pagerVisible={true}
        filterVisible={true}
        headerFilterVisible={true}
        props={{
          id: "account-email-list-grid",
          remoteOperations: true,
        }}
        columns={[
          {
            dataField: "id",
            visible: false
          },
          {
            dataField: "accountId",
            caption: t("account_name"),
            lookup: {
              dataSource: accountStore,
              valueExpr: "id",
              displayExpr: "name"
            }
          },
          {
            dataField: "emailAddress",
            caption: t("email")
          },
          {
            dataField: "name",
            caption: t("name")
          }
        ]}
      />
    </React.Fragment>
  );
};
export default App;